export default "__VITE_ASSET__DWS4Bre5__"